var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"geo-location-link",attrs:{"disabled":_vm.hasError,"title":_vm.$t('showLocation')},on:{"click":_vm.$_geolocationClick}},[_c('span',{staticClass:"geobutton"},[_c('span',{class:_vm.geolocationClass})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }